import { Component, OnInit } from '@angular/core';
import { ISlide } from 'src/app/commons/interfaces/slider.interface';

@Component({
  selector: 'pda-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  slides: ISlide[] = [
    {
      url: 'assets/images/home/slide_1.webp',
      showSlogan: true,
      position: 'bottom-left'
    },
    {
      url: 'assets/images/home/slide_2.webp',
      showSlogan: true,
      position: 'top-left'
    },
    {
      url: 'assets/images/home/slide_3.webp',
      showSlogan: false
    },
    {
      url: 'assets/images/home/slide_4.webp',
      showSlogan: true,
      position: 'bottom-left'
    },
    {
      url: 'assets/images/home/slide_5.webp',
      showSlogan: true,
      position: 'bottom-right'
    },
    {
      url: 'assets/images/home/slide_6.webp',
      showSlogan: true,
      position: 'top-right'
    },
    {
      url: 'assets/images/home/slide_8.webp',
      showSlogan: false
    },
    {
      url: 'assets/images/home/slide_9.webp',
      showSlogan: false
    },
    {
      url: 'assets/images/home/slide_10.webp',
      showSlogan: false
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
